const TodoTypes = {
  ATTENTION: 'attention',
  SIGNATURE: 'signature',
  RELEASE: 'release',
  PROCESS: 'process',
  CONTACT: 'contact',
}

export default Object.freeze(TodoTypes)
